@if (loading) {
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p>{{ 'manageEvent.contacts.loading' | translate }}</p>
  </div>
} @else {
  <div class="d-flex flex-wrap flex-stack mb-6">
    <h3 class="fw-bold my-2">{{ 'manageEvent.contacts.title' | translate }}</h3>
    <div class="d-flex flex-wrap my-2">
      <app-button
        [variant]="'primary'"
        [label]="'manageEvent.contacts.addContact' | translate"
        [iconClass]="'fa fa-plus'"
        (clicked)="openModal()"
      />
    </div>
  </div>
  <div class="row g-6 mb-6 g-xl-9 mb-xl-9">
    @for (contact of contacts; track contact.contact_id) {
      <div class="col-md-6 col-lg-4">
        <div class="card h-100">
          <div class="card-body d-flex flex-column">
            <div class="d-flex justify-content-between align-items-start mb-3">
              <div class="flex-grow-1">
                <h4 class="mb-1">{{ contact.first_name }} {{ contact.last_name }}</h4>
                <span class="badge badge-light-primary">{{ contact.role?.role_name || ('common.na' | translate) }}</span>
              </div>
              <div class="dropdown">
                <button class="btn btn-sm btn-light btn-icon d-flex align-items-center justify-content-center" type="button" data-bs-toggle="dropdown">
                  <i class="fa fa-ellipsis-v"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <a class="dropdown-item" (click)="openEditModal(contact)">
                      <i class="fa fa-edit me-2"></i>{{ 'common.edit' | translate }}
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item text-danger" (click)="deleteContact(contact)">
                      <i class="fa fa-trash me-2"></i>{{ 'common.delete' | translate }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="separator mb-3"></div>

            <div class="d-flex flex-column gap-2">
              @if (contact.email) {
                <div class="d-flex align-items-center">
                  <i class="fa fa-envelope text-muted me-2"></i>
                  <span class="text-gray-700">{{ contact.email }}</span>
                </div>
              }
              @if (contact.phone) {
                <div class="d-flex align-items-center">
                  <i class="fa fa-phone text-muted me-2"></i>
                  <span class="text-gray-700">{{ contact.phone }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    @if (!contacts || contacts.length === 0) {
      <div class="col-12 text-center text-muted py-10">{{ 'manageEvent.contacts.noContacts' | translate }}</div>
    }
  </div>
}
